import Splide from '@splidejs/splide';

export default {
  init() {
    // JavaScript to be fired on the about us page

    if($('#cross-sell-slider').length > 0){
      new Splide('#cross-sell-slider', {
        type: 'loop',
        arrows: $(this).data('arrows'),
        pagination: false,
        gap: '15px',
        perMove: 1,
        perPage: 4,
        autoplay: true,
        breakpoints: {
          1410: {
            perPage: 4,
          },
          1199: {
            perPage: 3,
          },
          992: {
            perPage: 2,
          },
          767: {
            perPage: 1,
          },
        },
      }).mount();
    }

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/cart.js